/**
=========================================================
* Trakib - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Trakib components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Trakib examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Trakib page layout routes
import pageRoutes from "page.routes";

// Trakib context
import { useMaterialUIController } from "context";

function IllustrationLayout({
  header,
  title,
  description,
  illustration,
  children,
}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  // styles for the typography with textGradient={true}
  // const gradientStyles = () => ({
  //   backgroundImage: linearGradient(gradients.dark.main, gradients.dark.state),
  //   display: "inline-block",
  //   WebkitBackgroundClip: "text",
  //   WebkitTextFillColor: transparent.main,
  //   position: "relative",
  //   zIndex: 1,
  // });

  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { gradients, transparent },
    functions: { linearGradient },
  }) => ({
    backgroundBlendMode: "overlay", // overlay / screen / darken / lighten
    backgroundImage: () =>
      `${linearGradient(
        gradients.info.main,
        gradients.info.state
      )}, url(${illustration})`,
  });
  return (
    <PageLayout background="white">
      {/* <DefaultNavbar
        routes={pageRoutes}
        action={{
          type: "external",
          route: "https://www.trakib.com/product/material-dashboard-pro-react-nodejs",
          label: "buy now",
        }}
      /> */}
      <Grid
        container
        sx={{
          backgroundColor: ({ palette: { background, white } }) =>
            darkMode ? background.default : white.main,
        }}
      >
        <Grid item xs={12} lg={6}>
          <MDBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(100% - 2rem)"
            height="calc(100vh - 2rem)"
            borderRadius="lg"
            ml={2}
            mt={2}
            // sx={{ backgroundImage: `url(${illustration})` }}
            sx={iconsStyle}
          />
        </Grid>
        <Grid item xs={11} sm={8} md={6} lg={4} xl={3} sx={{ mx: "auto" }}>
          <MDBox
            display="flex"
            flexDirection="column"
            justifyContent="center"
            height="100vh"
          >
            <MDBox py={3} px={3} textAlign="center">
              {!header ? (
                <>
                  <MDBox mb={1} textAlign="center">
                    <MDTypography variant="h4" fontWeight="bold">
                      {title}
                    </MDTypography>
                  </MDBox>
                  <MDTypography variant="body2" color="text">
                    {description}
                  </MDTypography>
                </>
              ) : (
                header
              )}
            </MDBox>
            <MDBox p={3}>{children}</MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

// Setting default values for the props of IllustrationLayout
IllustrationLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  illustration: "",
};

// Typechecking props for the IllustrationLayout
IllustrationLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.string,
};

export default IllustrationLayout;
